var React = require('react');

function Techbehemots (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".e{fill:#3ab64b;fill-rule:evenodd;}")),React.createElement("g",{"id":"a","key":1}),React.createElement("g",{"id":"b","key":2},React.createElement("g",{"id":"c"},React.createElement("path",{"id":"d","className":"e","d":"M38.39,23.72h-6.85V15.16h17.12c0,1.69-4.35,8.56-10.27,8.56ZM0,2.93V0L9.98,.02h0l26.79-.02c7.48,0,11.89,5.94,11.89,8.56H7.09c0-2.76-1.94-5.62-7.09-5.62ZM7.09,15.16H23.96v8.56H7.09V15.16Zm16.87,23.72H7.09v-8.56H23.96v8.56Zm7.58-8.56h7.58c7.68,0,11.49,6.15,11.49,8.56H31.54v-8.56ZM7.09,45.48H23.96v3.67h7.58v-3.67h19.07c0,3.03-5.49,8.56-11.25,8.56H0v-2.94c5.11,0,7.09-2.7,7.09-5.62Z"})))]);
}

Techbehemots.defaultProps = {"viewBox":"0 0 50.62 54.04"};

module.exports = Techbehemots;

Techbehemots.default = Techbehemots;
